import cx from 'classnames'
import {Field} from 'react-final-form'
import {TextArea} from '../inputs/TextArea'
import {ErrorMessage} from './ErrorMessage'
import {Label} from './Label'

type Props = {
  label?: string
  name: string
  required?: boolean
  placeholder?: string
  className?: string
  validate?: (value: any) => any
  format?: (value: any) => any
  parse?: (value: any) => any
  min?: number
  max?: number
  autoFocus?: boolean
  spellCheck?: boolean
}

export const TextAreaField = ({
  label,
  name,
  required,
  placeholder,
  className,
  validate,
  format,
  parse,
  min,
  max,
  autoFocus,
  spellCheck,
}: Props) => {
  return (
    <Field
      validate={validate}
      format={format}
      parse={parse}
      name={name}
      type="textarea"
      render={({input, meta}) => {
        const {active, dirty, error} = meta
        const showError = !active && dirty && error
        return (
          <div className={cx('flex flex-col', className)}>
            <div className="flex justify-between">
              {label && <Label required={required}>{label}</Label>}
              {showError && <ErrorMessage>{error}</ErrorMessage>}
            </div>
            <TextArea
              {...input}
              placeholder={placeholder}
              min={min}
              max={max}
              autoFocus={autoFocus}
              spellCheck={spellCheck}
            />
          </div>
        )
      }}
    />
  )
}
